module.exports = __webpack_public_path__ + "img/icon-protocol.ee2343b7.png";